import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQueries } from 'react-query';
import { CACHE_FOREVER, productTypeParam } from './priceQueries.utils';
export const usePremiumDomainPrices = (domains, productType) => {
  var _perDomain$find;
  const _DomainsApiClient$use = DomainsApiClient.useQueries(),
    listDisplayPrices = _DomainsApiClient$use.listDisplayPrices;
  const perDomain = useQueries(domains.map(domain => ({
    ...CACHE_FOREVER,
    queryKey: ['premiumDisplayPrice', domain, productType],
    queryFn: () => listDisplayPrices({
      domains: [{
        domain,
        premium: true
      }],
      ...productTypeParam(productType)
    })
  })));
  const pricesByDomain = new Map();
  perDomain.forEach((_ref, index) => {
    var _data$displayPrices;
    let data = _ref.data;
    const displayPrice = data == null || (_data$displayPrices = data.displayPrices) == null ? void 0 : _data$displayPrices[0];
    if (displayPrice) {
      pricesByDomain.set(domains[index], displayPrice);
    }
  });
  return {
    pricesByDomain,
    isLoading: perDomain.some(_ref2 => {
      let isLoading = _ref2.isLoading;
      return isLoading;
    }),
    pricesExcludeTax: (_perDomain$find = perDomain.find(_ref3 => {
      let data = _ref3.data;
      return data;
    })) == null || (_perDomain$find = _perDomain$find.data) == null ? void 0 : _perDomain$find.pricesExcludeTax
  };
};
//# sourceMappingURL=usePremiumDomainPrices.js.map